import { ReactNode } from 'react';
import {
    MENU_IMPORT_STEPS_ARIA,
    MENU_IMPORT_STEP_ADD,
    MENU_IMPORT_STEP_EXTRACT,
    MENU_IMPORT_STEP_REVIEW,
    MENU_IMPORT_STEP_UPLOAD,
} from '../../../../../../constants/strings';
import { JTranslation } from '../../../../../../helpers/jTranslationHelper';
import { useTranslation } from '../../../../../../hooks/useTranslation';
import { _ImportStep } from '../../../../../../helpers/menuImportHelper';

export type _StripStep = 'upload' | 'extract' | 'review' | 'add';

const STRIP_STEPS: { id: _StripStep; label: string }[] = [
    { id: 'upload', label: MENU_IMPORT_STEP_UPLOAD },
    { id: 'extract', label: MENU_IMPORT_STEP_EXTRACT },
    { id: 'review', label: MENU_IMPORT_STEP_REVIEW },
    { id: 'add', label: MENU_IMPORT_STEP_ADD },
];

const languageTexts = { STEPS_ARIA: MENU_IMPORT_STEPS_ARIA };

/** Maps the page step to the strip step: failed reads as Extract (it is where the import stopped). */
export const toStripStep = (step: _ImportStep | 'failed'): _StripStep => {
    switch (step) {
        case 'extracting':
        case 'failed':
            return 'extract';
        case 'ready':
            return 'review';
        case 'adding':
            return 'add';
        default:
            return 'upload';
    }
};

type Props = {
    current: _StripStep;
    quota?: ReactNode;
};

const StepsStrip = ({ current, quota }: Props) => {
    const translatedText = useTranslation(languageTexts, 'none');
    const currentIndex = STRIP_STEPS.findIndex((item) => item.id === current);
    return (
        <div className="bulk-upload-strip" data-testid="bulk-upload-strip">
            <ol className="bulk-upload-strip-steps" aria-label={translatedText.STEPS_ARIA ?? MENU_IMPORT_STEPS_ARIA}>
                {STRIP_STEPS.map((item, index) => {
                    const state = index < currentIndex ? 'done' : index === currentIndex ? 'current' : 'todo';
                    return (
                        <li
                            key={item.id}
                            className={`bulk-upload-strip-step ${state}`}
                            aria-current={state === 'current' ? 'step' : undefined}
                            data-testid={`strip-step-${item.id}`}
                        >
                            <span className="bulk-upload-strip-dot" aria-hidden="true">
                                {state === 'done' ? <i className="ri-check-line" /> : index + 1}
                            </span>
                            <span className="bulk-upload-strip-label">
                                <JTranslation text={item.label} typeCase="none" />
                            </span>
                        </li>
                    );
                })}
            </ol>
            {quota && <div className="bulk-upload-strip-quota">{quota}</div>}
        </div>
    );
};

export default StepsStrip;
